import { Api } from '$api';
import { CurrencyEnum } from '$store/models';

import { DailyEarningRow, StatisticsProDataset } from './StatisticsPro.types';

const DAY_SECONDS = 86400;

const toUtcDayStart = (unix: number) => Math.floor(unix / DAY_SECONDS) * DAY_SECONDS;

export interface StatisticsProQuery {
  from?: number;
  to?: number;
}

interface StatsProResponseRow {
  date: number;
  currency: string;
  earnings: Record<string, number> | null;
}

interface StatsProResponse {
  rows?: StatsProResponseRow[];
}

export async function fetchStatisticsPro(
  query: StatisticsProQuery = {},
): Promise<StatisticsProDataset> {
  const params: StatisticsProQuery = {};
  if (query.from !== undefined) params.from = toUtcDayStart(query.from);
  if (query.to !== undefined) params.to = toUtcDayStart(query.to);

  const data: StatsProResponse = await Api.get('/stats/pro', { params });

  const rows: DailyEarningRow[] = (data?.rows ?? []).map((row) => ({
    date: row.date,
    currency: row.currency as CurrencyEnum,
    earnings: row.earnings ?? {},
  }));
  rows.sort((a, b) => a.date - b.date);

  const days = Array.from(new Set(rows.map((row) => row.date))).sort((a, b) => a - b);

  return { rows, days };
}
